import React, { useState, useContext, useEffect } from 'react'
import { OrderLeft } from '../Icons/OrderDefined'
import User from '../Icons/User'
import Case from '../Icons/Case'
import OrderTabs from './OrderTabs'
import MyCalendar2 from '../myComponents/MyCalendar/MyCalendar2'
import MyCalendarDisable from '../myComponents/MyCalendar/MyCalendarDisable'
import intl from 'react-intl-universal'
import { OrderShopping } from './OrderShopping'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { Session } from '../../contexts/Session'
import { LanguageContext } from '../../contexts/LanguageContext'
import MyModal from '../myComponents/MyModal/MyModal'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import './OrderCss.css'
import Stethoscope from '../Icons/Stethoscope'
import People from '../Icons/People'
import Bed from '../Icons/Bed'
import {
  PatientInfo,
  HeaderWrapper,
  DoctorMsg,
  Navbottom
} from './OrderStyle.js'
import {
  addZero,
  updateMarkNum,
  updateDate,
  getDisableMealTypes,
  getEnAbleMealTypes,
  getPatientInfo,
  isObjEmpty,
  getDateStr
} from './OrderFunction'

export default function Order (props) {
  const [date, setDate] = useState(getDateStr(0).replace(/[/]/g, '')) // 订餐的基准日期，在此日期之前都不能定餐，之后都可以订，就在此日期需要校验餐次是否过期
  const SessionContext = useContext(Session)
  const Language = useContext(LanguageContext)
  const OrderMark = useContext(OrderMarkContext)
  const OrderInfo = useContext(OrderInfoContext)
  const [selectedDates, setSelectedDates] = useState([])
  const [mealTypeMarkObj, setMealTypeMarkObj] = useState({}) // 餐次的份数对象
  const [mealTypeIsShow, setMealTypeIsShow] = useState({}) // 根据病人的出院时间确定出院当天的那些餐次可以点餐
  // const enabledDates = []
  // console.log(enabledDates)
  // enabledDates.push(getDateStr(0))
  // enabledDates.push(getDateStr(1))
  // enabledDates.push(getDateStr(2))
  const [mealType, setMealType] = useState('')
  const [chooseDate, setChooseDate] = useState('')
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [maskIsshow, setMaskIsshow] = useState(false)
  const [advanceDay, setAdvanceDay] = useState(0) // 提前多少天预订
  const [targetDate, setTargetDate] = useState(getDateStr(advanceDay + 1).replace(/[/]/g, '')) // 当今天餐次过期，目标选中的日期
  const [disableMealTypes, setDisableMealTypes] = useState([])
  const [newDates, setNewDates] = useState([])
  // 设置可以点餐的日期
  useEffect(() => {
    let tmpDates = OrderMark.orderDateList.map(item => item.replace(/[-]/g, '')).sort((a, b) => a - b) // 获取后端返回的可点餐日期，并裁减排序处理
    tmpDates = tmpDates.filter(item => item >= date) // 以基准点餐日期为准，过滤出真正可以点餐的日期
    if (tmpDates.length) {
      tmpDates.includes(date) ? setChooseDate(date) : setChooseDate(tmpDates[0])
    } else { // 如果发现基准日期在可点餐日期之后，默认不选中任何日期
      setTargetDate('')
      setChooseDate('')
    }
  }, [OrderMark.orderDateList, date])
  // 根据病人的出院时间，设置当前日期的各个餐次是否可点餐
  useEffect(() => {
    const tmpoutHospitalDate = OrderMark.outHospitalTime && OrderMark.outHospitalTime.substr(0, 10).replace(/[-]/g, '')
    const tmpoutHospitalTime = OrderMark.outHospitalTime && OrderMark.outHospitalTime.substr(10, 8).replace(/[:]/g, '')
    // console.log(tmpoutHospitalDate)
    const showObj = {}
    OrderMark.mealtypes.forEach(item => {
      // console.log(item)
      if (tmpoutHospitalDate && chooseDate && item.mealTime && chooseDate === tmpoutHospitalDate && Number(item.mealTime.replace(/[:]/g, '')) > Number(tmpoutHospitalTime)) {
        showObj[`mealShow${item.id}`] = false
      } else {
        showObj[`mealShow${item.id}`] = true
      }
    })
    setMealTypeIsShow(showObj)
  }, [chooseDate, OrderMark.outHospitalTime, OrderMark.mealtypes])
  // 设置需要提前多少天预订饭菜
  useEffect(() => {
    if (!isObjEmpty(OrderMark.properties)) {
      if (OrderMark.properties.effectiveDays) {
        OrderMark.properties.effectiveDays.length > 0 && setAdvanceDay(OrderMark.properties.effectiveDays[0])
      }
    }
  }, [OrderMark.properties])
  // 设置订餐的基准日期
  useEffect(() => {
    setDate(getDateStr(advanceDay).replace(/[/]/g, ''))
  }, [advanceDay])
  // 设置餐次
  useEffect(() => {
    if (OrderMark.mealtypes.length) {
      setMealType(getEnAbleMealTypes(OrderMark.mealtypes, chooseDate, advanceDay, OrderMark.outHospitalTime))
    }
  }, [OrderMark.mealtypes, chooseDate, advanceDay, OrderMark.outHospitalTime])
  // 设置已经失效的餐次
  useEffect(() => {
    OrderMark.mealtypes.length > 0 && setDisableMealTypes(getDisableMealTypes(OrderMark))
  // eslint-disable-next-line
  }, [OrderMark.mealtypes])
  useEffect(() => {
    const tmpDates = OrderMark.orderDateList.sort((a, b) => a - b)
    if (chooseDate && date && chooseDate === date && disableMealTypes.length >= OrderMark.mealtypes.length) {
      const newDates = tmpDates.filter(item => item.replace(/[-]/g, '') > date)
      const targetDate = newDates.length ? newDates[0] : ''
      setNewDates(newDates)
      setTargetDate(targetDate)
      setChooseDate(targetDate.replace(/[-]/g, ''))
    }
  }, [disableMealTypes, OrderMark.mealtypes, OrderMark.orderDateList, date, chooseDate])
  useEffect(() => {
    setNewDates(OrderMark.orderDateList.sort((a, b) => a - b))
  }, [OrderMark.orderDateList])
  /** *如果App.js获取失败了，这里重新获取 床位号 和 饮食医嘱 */
  useEffect(() => { // 已做过测试
    if (!OrderMark.position || !OrderMark.foodAdvice || !OrderMark.patientName || !OrderMark.orderDateList) {
      // console.log('order补充获取病人床位号+饮食医嘱+姓名')
      getPatientInfo(OrderMark, SessionContext)
    }
  // eslint-disable-next-line
  }, [SessionContext])
  // 如果前端缓存的食物列表发生变化，更新每个餐次的所点份数
  useEffect(() => {
    updateMarkNum(OrderMark, OrderInfo, chooseDate, mealType, setMealTypeMarkObj)
    // console.log(OrderInfo.cacheAllFoodList)
  // eslint-disable-next-line
  }, [OrderMark.mealtypes, OrderInfo.cacheAllFoodList, chooseDate, mealType])

  useEffect(() => {
    updateDate(OrderInfo, setSelectedDates)
  // eslint-disable-next-line
  }, [OrderInfo.cacheAllFoodList])

  // console.log(chooseDate)
  return (
    <div className='h100 bgf ffyy'>
      <div
        className={'abs trbl0 bg0 zx8 op3' + (maskIsshow !== false ? ' ' : ' dn')}
        onClick={() => { setMaskIsshow(false) }}
      />
      {/* <PatientInfo className={'w61 p10 abs bgf zx50 rds5 fs12 trans4' + (maskIsshow === 'userInfo' ? ' op10' : ' op0')} style={{ top: '6%', right: '1.1428rem', transform: maskIsshow === 'userInfo' ? 'translateX(0%)' : 'translateX(130%)' }}> */}
      <PatientInfo className={'w61 p10 abs bgf zx50 rds5 fs12' + (maskIsshow === 'userInfo' ? ' ' : ' dn')} style={{ top: '6%', right: '1.1428rem' }}>
        <div className='h23r b ge5007e' style={{ borderBottom: '0.5px solid #dcdedd' }}>{intl.get('Your personal information:')}</div>
        <ul className='flex' style={{ borderBottom: '0.5px solid #dcdedd', height: '2.5rem' }}>
          <li className='w13'><Stethoscope width={16} height={16} /></li>
          <li className='w55 g8a8a8a'>{intl.get('HospitalizationNumber')}</li>
          <li className='w32 tr'>{OrderMark.pid}</li>
        </ul>
        <ul className='flex' style={{ borderBottom: '0.5px solid #dcdedd', height: '2.5rem' }}>
          <li className='w13'><People width={16} height={16} /></li>
          <li className='w40 g8a8a8a'>{intl.get('PatientName')}</li>
          <li className='w47 tr'>{OrderMark.patientName}</li>
        </ul>
        <ul className='flex' style={{ borderBottom: '0.5px solid #dcdedd', height: '2.5rem' }}>
          <li className='w13'><Bed width={16} height={16} /></li>
          <li className='w34 g8a8a8a'>{intl.get('BedID')}</li>
          <li className='w53 tr ovs nowrap minW0'>{OrderMark.position}</li>
        </ul>
      </PatientInfo>
      <HeaderWrapper className='h24 rel'>
        <MyHeaderBg wrapperStyle={{ zIndex: '0' }} />
        {/* 头部返回箭头和叉号 + 床位号 */}
        {/* <div className='h22'>
          <MyNavBar style={{ padding: '0' }} titleStyle={{ letterSpacing: '0.125rem', fontSize: '1.15rem' }} history={props.history} rightContentVisible={false}>{intl.get('Online ordering')}</MyNavBar>
        </div> */}
        <ul className='h23 pl14 pr16 pt9 flex'>
          <li className='w9 rel zx2' onClick={() => props.history.goBack()}><OrderLeft color={'#fff'} width={'14'} height={'14'} /></li>
          <li className={'w44 h100 lh1-5 rel zx2 fs16 gf' + (Language.locale === 'en' ? '' : ' lt1-5')}>{intl.get('Online ordering')}</li>
          <li className={'w46 flex rel' + (maskIsshow === 'userInfo' ? ' zx50' : '')} onClick={() => { setMaskIsshow('userInfo') }}>
            <div className='w78'>
              <div className='fs12-6 lt1-5 tr gf no-wrap minW0'>{OrderMark.position}</div>
            </div>
            <div className='w22 h16px rel'>
              <div className='abs r5 b-3'><User color={'#fff'} width={18} height={18} /></div>
            </div>
          </li>
        </ul>
        {/* 饮食医嘱 + 日期选择 */}
        <div className='h35 rel mr16'>
          <div className='h15' />
          <DoctorMsg className='h51 ml18 fs13'>
            <div
              className={'doctorIconBox wMax53 no-wrap dib pr10 lt1 rel patientHeight' + (maskIsshow === 'doctorAdvice' ? ' zx50' : '')}
              onClick={() => { setMaskIsshow('doctorAdvice') }}>
              <div className='abs t2 l9'>
                <Case height={17} width={17} />   {/* 医嘱的UI */}
              </div>
              {OrderMark.foodAdvice}
            </div>
            <div className='rel h100'>
              {/* <div className={'w53 abs zx50 wrap lh1-5 fs12 bgf rds6 trans4' + (maskIsshow === 'doctorAdvice' ? ' op10' : ' op0')} style={{ transform: maskIsshow === 'doctorAdvice' ? 'translateX(0%)' : 'translateX(-130%)' }}> */}
              <div className={'w53 abs zx50 wrap lh1-5 fs12 bgf rds6' + (maskIsshow === 'doctorAdvice' ? ' ' : ' dn')}>
                <div className='pt5 pb5 pl10 pr10 lt1'>
                  <b className='ge5007e'>{intl.get('Dietary advice:')}</b>
                  {OrderMark.foodAdvice}
                </div>
              </div>
            </div>
          </DoctorMsg>
          <div className='h70 w42 abs r0 t5 gf tl'>
            {
              targetDate === '' ? <MyCalendarDisable /> : <MyCalendar2
                getDate={(year, month, date) => {
                  const dateStr = `${addZero(year, 4)}${addZero(month, 2)}${addZero(date, 2)}`
                  setChooseDate(dateStr)
                  // console.log(year, month, date)
                }}
                defaultDate={chooseDate.slice(0, 4) + '/' + chooseDate.slice(4, 6) + '/' + chooseDate.slice(6)}
                selectedDates={selectedDates}
                enabledDates={newDates}
                setMealType={setMealType}
              />
            }
          </div>
          <div className='h39' />
        </div>
        <div className='h1' />
        {/* 餐次选择 */}
        <Navbottom className='flex h33 w98 auto pl12 pr16 pb3'>
          {
            // console.log(mealtypes)
            OrderMark.mealtypes.map(item => {
              return (
                <li
                  key={item.id}
                  className={
                    'bgf rel zx2 w14 h70 rds5 tc mt3 ovh ' +
                    (Number(chooseDate) < Number(date) && ' g939192 op8 ') +
                    (Number(chooseDate) === Number(date) && disableMealTypes.includes(item.id) && ' g939192 op8 ') +
                    (Number(chooseDate) === Number(date) && !disableMealTypes.includes(item.id) && ' g0 ') +
                    (Number(chooseDate) > Number(date) && ' g0 ') +
                    (mealType === item.id && ' food-type-active ')
                    // +(mealType === item.id ? ' food-type-active' : '')
                  }
                  style={{ maxHeight: '35px', color: mealTypeIsShow[`mealShow${item.id}`] === false ? '#939192' : '' }}
                  onClick={() => {
                    if (mealTypeIsShow[`mealShow${item.id}`] && ((Number(chooseDate) === Number(date) && !disableMealTypes.includes(item.id)) || Number(chooseDate) > Number(date))) {
                      item.id !== mealType && setMealType(item.id) // 餐次id
                    } else if (mealTypeIsShow[`mealShow${item.id}`] === false) {
                      setShowModal(true)
                      setModalInfo(intl.get("According to your discharge time, you can't order this meal."))
                    } else if (chooseDate === '') {
                      setShowModal(true)
                      setModalInfo(intl.get("According to your discharge time, you can't order this meal."))
                    } else {
                      setShowModal(true)
                      setModalInfo(intl.get('The meal has exceeded the deadline for ordering.'))
                    }
                  }}>
                  <div className='h100 w100 rel'>
                    <div className={'mask-box abs tc bgf h35 fs7 zx1 gf h10r w12r auto'} style={{ visibility: mealTypeMarkObj[`mealMark${item.id}`] > 0 ? 'visible' : 'hidden' }}>
                      <div className='w12r tc ml-2'>
                        <div style={{ transform: 'scale(0.9)' }}>{mealTypeMarkObj[`mealMark${item.id}`]}</div>
                      </div>
                    </div>
                    <div className='h100 vc'>
                      <div className='w100 tc lt1-5 fs13'>
                        {
                          Language.locale && Language.locale.includes('en') ? <div style={{ transform: 'scale(0.8)' }}>{item.mealName}</div> : item.mealName
                        }
                      </div>
                    </div>
                  </div>
                </li>
              )
            })
          }
        </Navbottom>
        <div className='h4' />
      </HeaderWrapper>
      <div className='h76'>
        <OrderTabs mealType={mealType} chooseDate={chooseDate} setMealTypeMarkObj={setMealTypeMarkObj} />
      </div>
      <div className='h7 w100 abs b0 l0 zx7' style={{ maxHeight: '48px' }}>
        <OrderShopping history={props.history} advanceDay={advanceDay} />
      </div>
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => setShowModal(false)}
      />
    </div>
  )
}
